import React from "react";
import {useHistory} from "react-router-dom";
import {useCurrentUser} from "~/auth/hooks";
import {IconButton, IconButtonProps} from "@mui/material";
import {Profile} from "~/ui/icons";


export type ProfileButtonProps = Omit<IconButtonProps, "children"> & {

}


export const ProfileButton = (props: ProfileButtonProps) => {
    const history = useHistory()
    const [user, loading] = useCurrentUser();

    const handleClick = () => {
        history.push("/profile");
    }

    return <>
        <IconButton {...props} onClick={handleClick} disabled={loading}>
            <Profile/>
        </IconButton>
    </>;
}